const MyMixin = {
  data() {
    return {};
  },
  mounted() {
    // 在组件挂载时进行操作
    //   this.showKeyBoard(); // 在组件中使用showKeyBoard方法
    this.showKeyBoard = () => {
      console.log("召唤键盘");
      window.startOsk();
    };
    this.closeKeyBoard = () => {
      console.log("关闭键盘");
      window.closeOsk();
    };
  }
};

export default MyMixin;



// WEBPACK FOOTER //
// ./src/utils/mixin.js